module.exports = __webpack_public_path__ + "media/images/culture-action-hover-6e9ea37679f840bf5049ff2daafbae18.png";